export default "/images/vendor/flag-icon-css/flags/1x1/cd.svg?d44809aaad5d32f91a56124d5f222aba";